import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import Title from './Title';
import ProductItem from './ProductItem';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Hoodies = () => {
    const { products } = useContext(ShopContext);
    const [hoodies, setHoodies] = useState([]);
   
    useEffect(() => {
        const filteredProducts = products.filter(product => product.category === 'Hoodies');
        setHoodies(filteredProducts.slice(0, 4));
    }, [products]);
    //  useEffect(() => {
    //         window.scrollTo(0, 0); // Scrolls to the top of the page
    //       }, []);
   
        const dynamicKeywords = hoodies.map(item => item.name).join(', ');

    return (
        <>
            {/* SEO Metadata */}
            <Helmet>
                <title>Oversized T-Shirts - Comfort and Style</title>
                <meta
                    name="description"
                    content="Explore our latest collection of oversized t-shirts, designed for ultimate comfort and unmatched style. Shop now and redefine casual fashion!"
                />
                <meta
                    name="keywords"
                    content={`oversized t-shirts, comfort, style, casual fashion, modern t-shirts, ${dynamicKeywords}`}
                />
            </Helmet>
        

        <div className='my-10 bg-[#e0e0e0]'>
            <div className='text-center py-8 text-3xl'>
            <Title text1={'HOODIES'} text2={'COLLECTION'} />
                {/* <p className='w-3/4 m-auto text-xs sm:text-sm md:text-base text-gray-600'>
                    Stay cozy with our premium hoodies designed for ultimate comfort and style.
                </p> */}
            </div>

            <div className='max-w-screen-xl mx-auto px-4'>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 gap-y-6">
                    {hoodies.map((item, index) => (
                        <ProductItem key={index} id={item._id} image={item.image} name={item.name} price={item.price} op={item.originalPrice} importance="high" />
                    ))}
                </div>
                <div className="text-center mt-8">
                    <Link to="/collection" className="text-white bg-orange-500 px-6 py-2 rounded-lg hover:bg-orange-600" >
                        See All
                    </Link>
                </div>
            </div>
        </div>
        </> 
    );
};

export default Hoodies;

// onClick={() => window.scrollTo(0, 0)}
// REMOVED from Link to = "" at last for scrolle